import { RulesDetailModel } from "./rules.detail.model";

export class RulesModel{
  cleansingRuleConfigId: number;
  dataSourceId: number;
  dataSourceName: string;
  tagName: string;
  createdBy: string;
  updatedBy: string;
  createdDate?: string;
  lastUpdatedDate?: string;
  cleansingRules: RulesDetailModel[];
  filterResponse?:any
}

